export default __webpack_public_path__ + "static/media/alert.6aa7cab9.svg";